import styled from "styled-components";
import ModelCard from "../ModelCard/ModelCard";

const BodyWrapper = styled.div`
  padding: 20px 20px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

const MarketPlaceGalleryView = () => {
  return (
    <BodyWrapper>
      {[...Array(10)].map(() => (
        <>
          <ModelCard
            iseFeatureModelCard={false}
            cardTitle="Demo feature model card"
          />
          <ModelCard iseFeatureModelCard={true} cardTitle="Demo model card" />
        </>
      ))}
    </BodyWrapper>
  );
};

export default MarketPlaceGalleryView;
